import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { SubscriptionProvider } from '../Settings/SubscripitionChecker.jsx'; // Zorg ervoor dat het pad correct is
import { SSEProvider} from "../Settings/SSEProvider.jsx";

const PrivateRoute = () => {
    // Voorbeeld van hoe je isAuthenticated kunt instellen
    // Dit kan een context zijn, lokale opslag, of een andere authenticator
    const isAuthenticated = !!sessionStorage.getItem('authToken'); // Vervang dit met je eigen logica

    return isAuthenticated ? (
        <SSEProvider>
        <SubscriptionProvider>
            <Outlet />
        </SubscriptionProvider>
        </SSEProvider>

    ) : (
        <Navigate to="/login" />
    );
};

export default PrivateRoute;
